

var _fbMessenger = require('../constants/fbMessenger');

var _fbMessenger2 = _interopRequireDefault(_fbMessenger);

var _index = require('../utils/index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var AUTORETURN_TIMEOUT = 5000;


define(['jquery', 'angular', 'squid/index', 'text!./template.html', 'components/xo-beaver/dist/logger', 'components/xo-return-to-merchant/dist/util'], function ($, ng, squid, template) {

    return angular.module('xo-done.directive', ['squid', 'beaver', 'xo-error-tooltip.directive', 'xo-return-to-merchant']).directive('xoDone', function () {

        return {
            template: template,
            controller: function controller($rootScope, $scope, $populate, $logger, $CheckoutAppDataModel, $CheckoutSessionModel, $MerchantPreferenceModel, $CheckoutPayeeModel, $CheckoutCartModel, $locale, $ReturnToMerchant, $DeviceInfo, $state, $window, $stateParams, $pxp, $timeout) {

                $scope.isGuestSignup = $rootScope.mode && $rootScope.mode === 'signup';
                $scope.locale = $locale;

                function addPageMessage(code) {
                    var CONTENT_KEY_MAPPING = {
                        NO_UPGRADE: 'accountUpgradeFailed'
                    };
                    if (code && CONTENT_KEY_MAPPING[code]) {
                        $scope.errorMessage = {
                            msgs: [$locale.content.get('done.' + CONTENT_KEY_MAPPING[code])],
                            type: 'warning'
                        };
                    }
                }

                $populate($scope, {
                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
                    checkoutSession: $CheckoutSessionModel.instance($scope.token),
                    checkoutCart: $CheckoutCartModel.instance($scope.token),
                    payee: $CheckoutPayeeModel.instance($scope.token)
                }).then(function () {

                    return $populate($scope, {
                        merchantPreferenceModel: $MerchantPreferenceModel.instance($scope.payee.merchant.id)
                    }).then(function () {
                        // Show auto return page when feature is enabled by merchant and txn
                        $scope.isAutoReturn = $scope.merchantPreferenceModel.autoReturn();

                        $logger.info('wps_autoreturn_' + ($scope.isAutoReturn ? 'enabled' : 'disabled'), {
                            return_url: $scope.checkoutAppData.urls.return_url || 'not_available',
                            autoreturn_url: $scope.merchantPreferenceModel.returnUrl() || 'not_available'
                        });

                        // Set content key based on device
                        $scope.autoReturnContentKey = $DeviceInfo.isMobile() || $DeviceInfo.isTablet() ? 'done.autoReturnStatement' : 'done.autoReturnStatementWeb';
                        $scope.guestSignupKey = $scope.isGuestSignup ? 'done.paymentGuest' : 'done.payment';
                        if ($stateParams.code) {
                            addPageMessage($stateParams.code);
                        }
                        var amount = $scope.checkoutSession.transactionDetails.amount.total;
                        var code = $scope.checkoutSession.transactionDetails.amount.currency;
                        $scope.formattedAmount = squid.formatCurrency(amount, code);
                        var itemList = $scope.checkoutSession.itemsList;

                        itemList.forEach(function (item) {
                            item.quantity = squid.formatQuantity(item.quantity);
                        });
                    });
                }).then(function () {
                    var pxpContext = _index2['default'].getMessengerPXPContext();
                    $logger.info('pxp_xo_wps_fb_messenger_plugin_1_treatment ', pxpContext);

                    $pxp(_fbMessenger2['default'].PXP_MESSENGER_EXPT, pxpContext, _fbMessenger2['default'].PXP_SHOW_MESSENGER_PLUGIN_TREATMENT).then(function (result) {
                        $logger.info('Messenger_done_page_PXP_RESULT', result);
                        if (result && result.treatment_name === _fbMessenger2['default'].PXP_SHOW_MESSENGER_PLUGIN_TREATMENT && !$scope.isAutoReturn) {
                            $logger.info('messenger_done_page_test_traffic');
                            $scope.pxpMessengerIntegrationEnabled = true;
                        } else {
                            $logger.info('messenger_done_page_control_traffic');
                            $scope.pxpMessengerIntegrationEnabled = false;
                        }
                    });

                    $('#outerWrapper').addClass('xo-done');

                    $scope.expansion = false;
                    $scope.toggle = function () {
                        if ($scope.expansion === false) {
                            $scope.maxHeight = document.getElementsByClassName('details-expand')[0].scrollHeight + 'px';
                            $scope.expansion = true;
                        } else {
                            $scope.expansion = false;
                        }
                        return $scope.expansion;
                    };

                    $scope.autoReturnStatementClick = function (event) {
                        event.preventDefault();
                        if (event.target && event.target.nodeName === 'A') {
                            $logger.info('autoreturn_statement_clicked');
                            $scope.returnToMerchant();
                        }
                    };

                    if ($scope.isAutoReturn) {
                        $logger.info('autoreturn_to_merchant');
                        $timeout($scope.returnToMerchant, AUTORETURN_TIMEOUT);
                    }
                });

                $scope.$on('localeChange', function () {
                    if ($stateParams.code) {
                        addPageMessage($stateParams.code);
                    }
                });

                $scope.returnToMerchant = function () {
                    $logger.info('return_to_merchant_clicked');
                    return $state.go('checkout.end');
                };

                $rootScope.$on('$stateChangeSuccess', function (event, newState, newParams, oldState) {
                    if (oldState.name === 'checkout.done') {
                        $('#outerWrapper').removeClass('xo-done');
                    }
                });
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/done/directive.js
// module id = ./components/xo-page-components/src/done/directive.js
// module chunks = 1